import {observable, action} from "mobx"
import * as api from "../services/api"
import Cookies from "js-cookie";


class RiderStore {
  @observable checkedInRiders = [];
  @observable allRiders = [];
  @observable displayedRiders = [];
  @observable rider = null;
  @observable loading = true;
  @observable riderSearch = "";

  @action
  getRidersCheckedIn = () => {
    this.allRiders = []
    this.checkedInRiders = []
    let rider = {};
    api
      .getRidersCheckedIn(Cookies.get("token"))
      .then(res => {
        this.loading = false;
        if (res.list) {
          if (res.list.length > 0) {
            res.list.forEach(r => {
              rider.name = r.name;
              rider.phone = r.phone_no;
              rider.id = r.rider_id;
              rider.dispatches = r.dispatches;
              rider.checked_in_at = r.checked_in_at;
              rider.backup = r.backup;
              rider.attendance_id = r.attendance_id
              rider.returned_cash = r.returned_cash
              this.checkedInRiders.push(rider);
            });
          }
          this.displayedRiders = [...this.checkedInRiders];
        }
      })
      .catch(e => {
        this.loading = false;
        alert(e);
      });
  };

  @action
  getRidersAll = () => {
    api.getRiders(Cookies.get("token")).then(res => {
      this.allRiders = res.list;
    });
  };

  @action
  handleChange = e => {
    let value = e.target.value;
    this.riderSearch = value;
    this.typeAhead(e.target.value);
  };

  @action
  typeAhead(input) {
    this.displayedRiders = [...this.checkedInRiders];
    const reg = new RegExp(input.toLowerCase(), "i");
    this.displayedRiders = this.displayedRiders.filter(i => reg.test(i.name));
  }
}

const store = new RiderStore()
export default store



// WEBPACK FOOTER //
// ./src/stores/RiderStore.js